import CatalogItemCrud from "../components/catalog-item/CatalogItemCrud";

const CatalogItemsPage = () => {
  return (
    <>
      <CatalogItemCrud />
    </>
  );
};

export default CatalogItemsPage;
